<template>
  <div
    class="card__border"
    v-bind:class="{ 'active-selection': selectedIndex == index }"
    v-if="optionValue"
    @click="selectOption"
  >
    <div
      v-if="
        optionValue.Images &&
          optionValue.Images.NormalSize &&
          optionValue.Images.NormalSize.length > 0
      "
      class="card__image"
    >
      <img :src="optionValue.Images.NormalSize[0].Url" />
    </div>
    <div class="card__mobile-col">
      <div class="card__col-middle">
        <div class="card__title" :data-enhanced-option="optionValue.Text">
          {{ optionValue.Text }}
        </div>
        <div class="card__partNumber" v-if="isPart">
          {{ optionValue.Value }}
        </div>
        <div v-if="optionValue.ModalLabelText" class="card__leadTime">
          {{ optionValue.ModalLabelText }}
        </div>
      </div>
      <div
        class="card__priceWrapper"
        v-if="true === optionValue.IsThirdPartyProduct"
      >
        <div class="card__price">
          Included
        </div>
      </div>
      <div v-else class="card__priceWrapper">
        <div v-if="null !== optionValue.Price">
          <div v-if="showLoginMsg">
              <legrandav-link label="Sign in" @click="onLoginClick"></legrandav-link>
          </div>
          <div v-else class="card__priceWrapper">
            <div class="card__price">
              {{ optionValue.Price.FormattedPrice }}
            </div>
            <div class="card__msrp">
              MSRP: {{ optionValue.Price.FormattedMSRP }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UtilityService from "../../services/UtilityService";
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    optionValue: {
      type: Object,
      default: function() {
        return [];
      }
    },
    index: {
      type: Number,
      default: function() {
        return null;
      }
    },
    selectedIndex: {
      type: Number,
      default: function() {
        return null;
      }
    },
    currentIndex: {
      type: Number,
      default: function() {
        return null;
      }
    },
    isPart: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  computed: {
    ...mapGetters("user", ["getIsUserLoggedIn"]),
    ...mapGetters("enhancedproduct", [
      "getcustomHPLData",
      "getcustomHPLFormData",
      "getSelectedOptions",
      "getSaveAndContinueItem"
    ]),
    showLoginMsg() {
      // Price object isn't set
      const { Price } = this.optionValue;
      if (null === Price) {
        return false;
      }
      // logged in
      const priceStr = this.optionValue.Price.FormattedPrice;
      const priceHasPleaseCallMsg = priceStr.toLowerCase().includes("please");
      if (this.getIsUserLoggedIn) {
        return false;
      }
      // not logged in and price object exists
      else {
        return priceHasPleaseCallMsg;
      }
    }
  },
  data() {
    return {
      // currentIndex: null,
      nullCustomHPLData: {
        Id: null,
        RulesKey: null,
        ColorName: null,
        ColorNumber: null
      }
    };
  },
  components: {},
  methods: {
    ...mapActions("enhancedproduct", ["setIsCustomHPL", "setCustomHPLData"]),
    selectOption() {
      // this.currentIndex = this.index;
      this.$emit("select-option", this.optionValue, this.index);
      // Trigger Custom HPL color slide out if Wilsonart or Formica is choosen
      // get the custom hpl Front-end data from the state
      let allListItems = this.getSaveAndContinueItem.sectionOptionValues;
      let hplInfo = this.getSaveAndContinueItem.sectionOptionValues[2].CustomModalUIDetails;
      // declare the woodfinish
      
      // show component only if the url is not Null - Controlled in Sitecore.
      if (hplInfo !== "Null") {
        if ((this.optionValue.hasOwnProperty("Text") &&
            this.optionValue.ShowAdditionalModal === true)) {
          this.$store.dispatch("enhancedproduct/setIsCustomHPL", true);
          // find the matched woodfinish with translationcode
          allListItems.forEach(option => {          
              if (option.RulesKey === 'FinishId') {
                option.CustomModalUIDetails.forEach(config => {
                    const translationCodes = config.TranslationCode;
                    option.Values.forEach(value => {
                        if (translationCodes === this.optionValue.TranslationCode && 
                        this.optionValue.ShowAdditionalModal === true) {
                            //handle store dispatch
                            if (config.ManufacturerPlaceholder) {
                              this.$store.dispatch("enhancedproduct/setIsOtherCustomHPL", true);
                            } else {
                              this.$store.dispatch("enhancedproduct/setIsOtherCustomHPL", false);
                            }                           
                            const valueRulesKey = value.RulesKey;
                            value.RulesKey = this.optionValue.RulesKey;
                            //store dispatch actions
                            this.$store.dispatch("enhancedproduct/setCustomHPLData", {
                              Id: this.optionValue.Text,
                              RulesKey: value.RulesKey,
                              ReferenceUrl: hplInfo ? config.NameMoreInfoResult : "",
                              ReferenceText: hplInfo ? config.NameMoreInfo : "",
                              ColorNamePlaceholder: hplInfo ? config.NamePlaceholderText : "",
                              ColorNumberPlaceholder: hplInfo ? config.NumberPlaceholderText : "",
                              ManufacturerPlaceholder: (hplInfo && config.ManufacturerPlaceholder) ? config.ManufacturerPlaceholder : "",
                              ColorNumberNote: (hplInfo && config.ColorNumberNote) ? config.ColorNumberNote : ""
                            });
                            value.RulesKey = valueRulesKey ;
                        }                        
                    });
                });
              }  
          });
        } else if (this.getSelectedOptions[2]) {
          if (this.getcustomHPLFormData.length > 0) {
            for (let i = 0; i < this.getcustomHPLFormData.length; i++) {
              if (
                this.getcustomHPLFormData[i].RulesKey ===
                  this.optionValue.RulesKey &&
                this.getcustomHPLFormData[i].Id !== this.optionValue.Text
              ) {
                this.$store.dispatch(
                  "enhancedproduct/deleteCustomHPLFormData",
                  {
                    RulesKey: this.getcustomHPLFormData[i].RulesKey,
                    Id: this.getcustomHPLFormData[i].Id
                  }
                );
              }
            }
          }
        }
      }
    },
    getCurrentSelection() {
      if (this.currentIndex == this.index) {
        return true;
      } else if (this.selectedIndex == this.index) {
        return true;
      } else {
        return false;
      }
    },
    onLoginClick() {
      UtilityService.openSignInMenu();
      this.$store.dispatch("enhancedproduct/updateEnhancedLocalStorage");
    },
  }
};
</script>

<style lang="scss" scoped>
.card {
  &__border {
    border: 1px solid $gray-light;
    cursor: pointer;
    display: flex;
    margin-bottom: 20px;
    padding: 10px;
    &:hover {
      border: 1px solid $aqua;
    }

    &.active-selection {
      border: 2px solid $aqua;
    }
  }

  &__image {
    width: 60px;
    height: 60px;
    border: 1px solid $gray-light;
    min-width: 60px;
    margin: 0 10px 0 0;
    img {
      width: 100%;
      height: auto;
    }
  }

  &__col-middle {
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    margin: 0 10px 0 0;
  }

  &__title {
    font-size: 16px;
    letter-spacing: 0.25px;
    line-height: 24px;
    color: $gray-darker;
    text-align: left;
    font-family: $font-family-sans-serif-medium;
    // @include media-breakpoint-up(md) {
    //   max-width: 140px;
    // }
    // @include media-breakpoint-up(lg) {
    //   max-width: 160px;
    // }
  }

  &__leadTime {
    letter-spacing: 0.25px;
    line-height: 18px;
    font-size: 12px;
    color: $gray-dark;
    text-align: left;
    font-family: $font-family-base;
  }

  &__mobile-col {
    display: flex;
    flex: auto;
    @include media-breakpoint-down(sm) {
      flex: unset;
      flex-direction: column;
      justify-content: flex-start;
    }
  }

  &__priceWrapper {
    display: flex;
    flex-direction: column;
    margin: 0 0 0 auto;
    @include media-breakpoint-down(sm) {
      margin: 0 0 0 0;
    }
    a {
      color: $aqua;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  &__price {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: right;
    color: $gray-darker;
    font-family: $font-family-sans-serif-medium;
    @include media-breakpoint-down(sm) {
      text-align: left;
    }
  }

  &__msrp {
    letter-spacing: 0.25px;
    line-height: 18px;
    text-align: right;
    font-size: 12px;
    color: $gray-dark;
    font-family: $font-family-base;
    @include media-breakpoint-down(sm) {
      text-align: left;
    }
  }

  &__partNumber {
    color: $gray-dark;
    font-size: 12px;
    letter-spacing: 0.25px;
    line-height: 18px;
  }
}
</style>
